import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

  // create holiday
const createHoliday = (params) => {
  const { axiosInstance ,config} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.holidays.createHolidays}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

  // get holiday
  const getHoliday = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.holidays.getHolidays}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  // update holiday
  const updateHoliday = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.holidays.updateHoliday}`,
      method: "PUT",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

    // delete holiday
    const deleteHoliday = (params) => {
      const { axiosInstance ,config} = getAxiosConfig();
      const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.holidays.deleteHoliday}`,
        method: "DELETE",
        data: params,
        headers: config.headers ||null,
        mode: "no-cors",
      })
        .then((res) => {
          return setFormatedResponse(res);
        })
        .catch((error) => {
          return getFomatedError(error);
        });
      return response;
    };

    const uploadHoliday = (params) => {
      const dataParam = {
          type: 'upload', // Specify upload type
      };
      const { axiosInstance, config } = getAxiosConfig(dataParam);
      const response = axiosInstance({
          url: `${baseUrls.main}/${apiUrls.holidays.uploadHoliday}`,
          method: "POST",
          data: params,
          headers: config.headers || null,
          mode: "no-cors",
      })
          .then((res) => {
              return setFormatedResponse(res);
          })
          .catch((error) => {
              return getFomatedError(error);
          });
      return response;
  };

    // download sample
    const downloadSample = (params) => {
      const { axiosInstance ,config} = getAxiosConfig();
      const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.holidays.downloadSample}`,
        method: "GET",
        params: params,
        headers: config.headers ||null,
        mode: "no-cors",
      })
        .then((res) => {
          return setFormatedResponse(res);
        })
        .catch((error) => {
          return getFomatedError(error);
        });
      return response;
    };


export default {
    createHoliday,
    getHoliday,
    updateHoliday,
    deleteHoliday,
    downloadSample,
    uploadHoliday,
}